import React from "react";
import "./UserSearchCard.css";
import SearchIcon from "@material-ui/icons/Search";
import SwitchToggleComponent from "../../switchToggle";

// Top card: pick login type, search a user by email/phone, and run the
// primary user actions. Purely presentational — all handlers live in the page.
export default function UserSearchCard({
  options,
  initialLoginType,
  onLoginTypeChange,
  email,
  onEmailChange,
  loginType,
  onGetCredits,
  onClearCache,
  onGetAllEmails,
  onAddCoaching,
  onSearchEnter,
}) {
  const placeholder =
    loginType === 2 ? "E-posta adresi" : "Telefon numarası / E-posta";

  return (
    <div className="user-search-card">
      <div className="user-search-toggle">
        <SwitchToggleComponent
          options={options}
          initialValue={initialLoginType}
          onValueChange={onLoginTypeChange}
        />
      </div>

      <div className="user-search-input-wrapper">
        <SearchIcon className="user-search-icon" />
        <input
          className="user-search-input"
          type="text"
          placeholder={placeholder}
          value={email}
          onChange={(e) => onEmailChange(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && onSearchEnter) onSearchEnter();
          }}
        />
      </div>

      <div className="user-search-actions">
        <button
          type="button"
          className="credit-btn credit-btn-primary"
          onClick={onGetCredits}
        >
          Get User Credit List
        </button>
        <button
          type="button"
          className="credit-btn credit-btn-secondary"
          onClick={onGetAllEmails}
        >
          Get All User Email
        </button>
        <button
          type="button"
          className="credit-btn credit-btn-secondary"
          onClick={onClearCache}
        >
          Clear Cache
        </button>
        <button
          type="button"
          className="credit-btn credit-btn-accent"
          onClick={onAddCoaching}
        >
          Add Coaching to User
        </button>
      </div>
    </div>
  );
}
